__turbopack_context__.v({
  "className": "dancing_script_52f8f435-module__IIFTia__className",
});
